import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createSpecialNumber } from 'API/SpecialNumbers/createSpecialNumber';

const useCreateSpecialNumber = (onSuccess, onError) => {
    const queryClient = useQueryClient();

    const create = async (specialNumberData) => {
        const response = await createSpecialNumber(specialNumberData);
        return response.data;
    };

    return useMutation({
        mutationFn: create,
        onSuccess: (data) => {
            queryClient.invalidateQueries({ queryKey: ['SpecialNumbers'] });
            if (onSuccess) {
                onSuccess(data);
            }
        },
        onError: (error) => {
            if (onError) {
                onError(error);
            }
        },
    });
};

export default useCreateSpecialNumber;
